module.exports = __webpack_public_path__ + "img/jiangpai-1.b4be2812.svg";